import type { Recipe } from '../types';

export const initialRecipes: Recipe[] = [
  // Veggie Burger
  {
    menuItemId: 205,
    ingredients: [
      { inventoryItemId: 1, quantity: 1 }, // Beef Patties (pretend it's a veggie patty)
      { inventoryItemId: 2, quantity: 1 }, // Burger Buns
      { inventoryItemId: 3, quantity: 2 }, // Cheddar Cheese Slices
      { inventoryItemId: 4, quantity: 0.05 }, // 50g Tomatoes
      { inventoryItemId: 5, quantity: 0.1 }, // 1/10th of a lettuce head
    ],
  },
  // Grilled Salmon
  {
    menuItemId: 202,
    ingredients: [
      { inventoryItemId: 12, quantity: 1 }, // Salmon Fillets
    ],
  },
  // French Fries
  {
    menuItemId: 501,
    ingredients: [
      { inventoryItemId: 6, quantity: 0.3 }, // 300g Potatoes
      { inventoryItemId: 7, quantity: 0.05 }, // 50ml Cooking Oil
      { inventoryItemId: 8, quantity: 0.005 }, // 5g Salt
    ],
  },
  // Latte
  {
    menuItemId: 404,
    ingredients: [
      { inventoryItemId: 10, quantity: 0.02 }, // 20g Coffee Beans
      { inventoryItemId: 11, quantity: 0.2 }, // 200ml Milk
    ],
  },
   // Cola
  {
    menuItemId: 401,
    ingredients: [
      { inventoryItemId: 9, quantity: 0.1 }, // 100ml Cola Syrup
    ],
  },
];
